import type { Game } from '../stores/game/GameStore';

const fallbackThumbnailUrl = '/images/seven.png';

export const getThumbnailUrl = (data: Game, key?: 'Short' | 'Long'): string =>
  data[`thumbnail${key || ''}HrUrl`] || data[`thumbnail${key || ''}Url`] || fallbackThumbnailUrl;
